import { useCallback, useRef } from "react";

export function useSwipeNavigation({
  onPrev,
  onNext,
  enabled = true,
  threshold = 48,
  maxVertical = 72,
} = {}) {
  const startRef = useRef(null);

  const onTouchStart = useCallback(
    (e) => {
      if (!enabled) return;
      const t = e.touches[0];
      if (!t) return;
      startRef.current = { x: t.clientX, y: t.clientY };
    },
    [enabled],
  );

  const onTouchEnd = useCallback(
    (e) => {
      if (!enabled || !startRef.current) return;
      const t = e.changedTouches[0];
      if (!t) {
        startRef.current = null;
        return;
      }
      const dx = t.clientX - startRef.current.x;
      const dy = t.clientY - startRef.current.y;
      startRef.current = null;
      if (Math.abs(dx) < threshold) return;
      if (Math.abs(dy) > maxVertical && Math.abs(dy) > Math.abs(dx)) return;
      if (dx < 0) onNext?.();
      else onPrev?.();
    },
    [enabled, threshold, maxVertical, onNext, onPrev],
  );

  return { onTouchStart, onTouchEnd };
}
